import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { answersApi, Answer } from "../api";

interface AnswersState {
  answers: Record<number, Answer>;
  loading: boolean;
}

const initialState: AnswersState = {
  answers: {},
  loading: false,
};

export const fetchAnswers = createAsyncThunk(
  "answers/fetch",
  async (templateId: number) => {
    const { data } = await answersApi.getByTemplate(templateId);
    return data;
  }
);

export const saveAnswer = createAsyncThunk(
  "answers/save",
  async (payload: {
    questionId: number;
    text: string;
    preset?: string;
    clientQuestion?: string;
  }) => {
    const { data } = await answersApi.upsert(
      payload.questionId,
      payload.text,
      payload.preset,
      payload.clientQuestion,
    );
    return data;
  }
);

export const answersSlice = createSlice({
  name: "answers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnswers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAnswers.fulfilled, (state, action) => {
        state.answers = action.payload.reduce(
          (acc, answer) => ({ ...acc, [answer.questionId]: answer }),
          {}
        );
        state.loading = false;
      })
      .addCase(saveAnswer.fulfilled, (state, action) => {
        const answer = action.payload;
        // preserve questionText from prior state — backend upsert row doesn't
        // include it (it comes from the joined questions table)
        const prev = state.answers[answer.questionId];
        state.answers[answer.questionId] = {
          ...answer,
          questionText: prev?.questionText ?? answer.questionText ?? "",
        };
      });
  },
});
